var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"active":_vm.$store.state.sidebars.showPortfolioDetail}},[(_vm.$store.state.sidebars.showPortfolioDetail)?_c('portfolio-form',{attrs:{"data":_vm.$store.state.sidebars.showPortfolioDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }